<template lang="pug">
  b-card.text-left(:title="name")
    b-card-img( v-if="category.image_1" :src="assets_base_url + category.image_1" fluid )
    b-card-text {{description}}
    b-row(no-gutters)
      b-col(cols="6" v-for="sub,idx in subcategories" :key="sub.id" v-show="idx<more_limit || (idx>=more_limit && more)")
        b-link(:to="'/products/'+sub.id")
          b-card-img-lazy( :src="assets_base_url + sub.image_1" fluid)
          h6.text-dark {{$root.lang === 'zh' ? sub.name_zh : sub.name_en }}
    b-link(@click="viewMore" v-if="subcategories.length > more_limit")
      span(v-if="!more") {{tlang('products.view_more')}}
      span(v-else="more") {{tlang('products.view_fewer')}}
</template>

<script>
import LangMixin from '../common/lang/util'
export default {
  name: 'CategoryInfo',
  mixins: [LangMixin],
  props: {
    more_limit: {
      type: Number,
      default: 4
    },
    category: Object,
  },
  data: function(){
    return {
      more: false,
      assets_base_url: process.env.VUE_APP_ASSETS_URL,
      name: "",
      description: "",
    }
  },
  computed: {
    subcategories: function(){
      //Only subcategories with a valid image...
      return this.$root.categories.reduce((agg,cat)=>{
        if (cat.parent_id == this.category.id && cat.image_1){
          agg.push(cat);
        }
        return agg;
      },[]);
    },
  },
  created: function(){
    if(navigator.language.startsWith('zh')){
      this.name = this.category.name_zh;
      this.description = this.category.description_zh;
    } else {
      this.name = this.category.name_en;
      this.description = this.category.description_en;
    }
  },
  methods: {
    viewMore: function(){
      this.more = !this.more;
    }
  }
}
</script>